import { Dispatch, SetStateAction } from 'react';
import { ModalState } from '../../models';
import {
  ModalContent,
  ModalContentWrapper,
  ModalTitle,
  ModalTitleWrapper,
} from '../common/Modal';
import { Link } from '../styled/Link';
import { H4 } from '../styled/typography';
import { PersonInListV3 } from '../../models/person';

export function PeopleModal({
  personList,
  setModalState,
}: {
  personList: PersonInListV3[];
  setModalState: Dispatch<SetStateAction<ModalState>>;
}) {
  const personsBySpecialization: [
    string,
    [{ fullName: string; slug: string }]
  ][] = Object.entries(
    personList.reduce((acc, person) => {
      person.specialization_titles?.forEach((title) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (!acc[title]) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          acc[title] = [];
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        acc[title].push({
          fullName: [person.first_name, person.last_name].join(' '),
          slug: person.slug,
        });
      });
      return acc;
    }, {})
  );
  return (
    <ModalContentWrapper>
      <ModalTitleWrapper setModalState={setModalState}>
        <ModalTitle>Творческая группа</ModalTitle>
      </ModalTitleWrapper>
      <ModalContent>
        {personsBySpecialization.map(([specialization, artistList]) => (
          <div
            key={specialization}
            css={{ display: 'flex', padding: '0 8px 10px 8px', gap: 8 }}
          >
            <H4 css={{ width: '33%' }}>{specialization}:</H4>

            <div css={{ width: '67%' }}>
              {artistList.map((person, i) => (
                <button
                  css={{ paddingRight: 5 }}
                  onClick={() => setModalState({ show: false, content: '' })}
                  type='button'
                  key={`${specialization}-${person.slug}`}
                >
                  <Link href={['', 'person', person.slug, ''].join('/')}>
                    <span css={{ color: '#f44336' }}>
                      {person.fullName}
                      <span css={{ color: '#000000' }}>
                        {artistList.length === i + 1 ? '' : ','}
                      </span>
                    </span>
                  </Link>
                </button>
              ))}
            </div>
          </div>
        ))}
      </ModalContent>
    </ModalContentWrapper>
  );
}
